<template>
  <section class="c-section c-section--contacto">
    <MainBanner
      slider="false"
      bg1="6"
      bg2=""
      bg3=""
      title1="Esport as a profitable "
      title2="investment for brands"
      showText="true"
      :textBanner="banner.text"
      showBtn="false"
      btnUrl=""
    ></MainBanner>
    <BottomForm></BottomForm>
    <div class="c-map">
      <div class="container">
        <div class="c-map__wrapper">
          <h2 data-aos="fade" data-aos-delay="200" class="c-map__title mb-0">
            <strong class="pri-color">
              Offices in:
            </strong> <br>
            <span>
              Doha and Lima
            </span>
          </h2>
        </div>
        <!-- <div class="c-map__iframe w-100">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31207.958287351852!2d-77.00977746523441!3d-12.112508999999969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c7aeeb83951d%3A0x4f5f73959beb8390!2sCircuit%20Media%20Group!5e0!3m2!1ses-419!2spe!4v1682124467415!5m2!1ses-419!2spe" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  helpers,
} from 'vuelidate/lib/validators';
import Swiper, {
  Autoplay,
  Navigation,
  Pagination,
  EffectFade,
} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export default {
  data() {
    return {
      banner: {
        text: `We are a company that was born 10 years ago in the living room of one of our
        partners, we never raised money because we always created sustainable projects and
        its the same philosophy
        we had for the stakeholders that work with us, we work
        hard to make their
        sponsorship worth and ve valuable thought time`,
      },
      name: '',
      email: '',
      attachment: '',
      gallerySlider: null,

      submitStatus: '',
    };
  },
  components: {
    BottomForm: () => import(/* webpackChunkName: "bottomForm" */'../components/BottomForm.vue'),
    MainBanner: () => import(/* webpackChunkName: "mainBanner" */'../components/MainBanner.vue'),
  },
  mounted() {
    setTimeout(() => {
      this.gallerySlider = new Swiper('.gallerySlider .swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        touch: true,
        autoplay: {
          delay: 3000,
          speed: 1000,
        },
        loop: true,
        // effect: 'fade',
        navigation: {
          nextEl: '.gallerySlider .swiper-button-next',
          prevEl: '.gallerySlider .swiper-button-prev',
        },
      });
    }, 1000);
  },
  validations: {
    name: {
      required,
      minLength: minLength(4),
    },
    email: {
      required,
      alpha: helpers.regex('alpha', /.+@.+\..+/),
    },
    attachment: {
      file: {
        required: requiredIf(function file() {
          return this.attachment.length === 0;
        }),
      },
    },
  },
  methods: {
    asd() {
      return this.attachment.length !== 0;
    },
    attachmentFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        this.attachment = '';

        return;
      }

      [this.attachment] = files;
    },

    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
      } else {
        this.submitStatus = 'PENDING';
        /* OK code here!!! */
      }
    },
  },
};
</script>
